import {create} from 'zustand';
import MessagesAPI from '../services/MessagesAPI'

interface MessagesStateInterface {
    messageInformation: null|string;
    messageAlert: null|string;
    loaded: boolean;
    fetch: () => void;
    setLoaded: (loaded: boolean) => void;
}

export const useStoreMessages = create<MessagesStateInterface>((set, get) => ({
    messageInformation: null,
    messageAlert: null,
    loaded: false,
    fetch: async () => {
        if (!get().loaded) {
            await MessagesAPI.getMsgInfos()
                .then(({data: messageInformation}): void => {
                    if (messageInformation) {
                        set({messageInformation});
                    }
                });

            await MessagesAPI.getMsgAlertes()
                .then(({data: messageAlert}): void => {
                    if (messageAlert) {
                        set({messageAlert});
                    }
                });

            set({loaded: true});
        }
    },
    setLoaded: (loaded) => set({loaded})
}));